var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraIntegration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_6410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1047 15.1057L15.9995 0.000488281L0.894238 15.1057C0.657434 15.3435 0.524475 15.6654 0.524475 16.001C0.524475 16.3366 0.657434 16.6585 0.894238 16.8963L15.9995 32.0015L31.1047 16.8963C31.3415 16.6585 31.4745 16.3366 31.4745 16.001C31.4745 15.6654 31.3415 15.3435 31.1047 15.1057ZM15.9995 20.7304L11.2686 15.9994L15.9995 11.2685L20.7304 15.9994L15.9995 20.7304Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 11.2997C14.5115 9.81192 13.6727 7.79575 13.6662 5.69155C13.6598 3.58735 14.4862 1.5661 15.9651 0.0692139L5.58142 10.3873L11.2154 16.0213L15.9995 11.2997Z",
    fill: "url(#paint0_linear_319_6410)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7429 15.9869L15.9995 20.7304C16.7397 21.4701 17.3268 22.3484 17.7274 23.3151C18.128 24.2818 18.3342 25.3179 18.3342 26.3644C18.3342 27.4108 18.128 28.447 17.7274 29.4137C17.3268 30.3804 16.7397 31.2587 15.9995 31.9984L26.3738 21.6241L20.7429 15.9869Z",
    fill: "url(#paint1_linear_319_6410)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_6410",
    x1: 15.1558,
    y1: 6.48441,
    x2: 8.54998,
    y2: 13.0902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_319_6410",
    x1: 16.9026,
    y1: 25.4613,
    x2: 23.4959,
    y2: 18.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_6410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraIntegration);
export default __webpack_public_path__ + "static/media/jira-integration.9f6f8233e789897e36d3c3e33a3b24c0.svg";
export { ForwardRef as ReactComponent };